var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "#018489", fillRule: "evenodd" },
      React.createElement("circle", { opacity: ".07", cx: "24", cy: "24", r: "24" }),
      React.createElement("path", { d: "M20.026 23.63c1 .846 2.4 1.37 3.949 1.37s2.949-.524 3.948-1.368a6.454 6.454 0 015.052 5.118l.321 1.689A3 3 0 0130.35 34H17.6a3 3 0 01-2.947-3.561l.322-1.689a6.46 6.46 0 015.051-5.12zm-.23 1.086l-.223.07a5.461 5.461 0 00-3.616 4.151l-.322 1.689A2 2 0 0017.6 33h12.75a2 2 0 001.964-2.374l-.322-1.689a5.456 5.456 0 00-3.838-4.22c-1.16.823-2.63 1.283-4.18 1.283-1.446 0-2.823-.4-3.942-1.124l-.236-.16zM23.975 13a4.5 4.5 0 014.5 4.5V19a4.5 4.5 0 11-9 0v-1.5a4.5 4.5 0 014.5-4.5zm0 1a3.5 3.5 0 00-3.5 3.5V19a3.5 3.5 0 007 0v-1.5a3.5 3.5 0 00-3.5-3.5z", fillRule: "nonzero" })
    )
  );
});